import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Res } from 'src/app/models';
import { NotificationService, DialogModalService, ValidatorsService, LanguageService } from 'src/app/services';
import { ApispecificationService } from 'src/app/services/api-specifications.service';
import { SpecificationsFormulaValidator } from '../specifications-formula-validator';

@Component({
  selector: 'app-specifications-formula-settings',
  templateUrl: './specifications-formula-settings.component.html',
  styleUrls: ['./specifications-formula-settings.component.css']
})
export class SpecificationsFormulaSettingsComponent implements OnInit {

  progressRef: NgProgressRef;
  errorMessages: any;
  subscriptions: Subscription = new Subscription();

  formulaForEdit: any[] = [];
  isFormulaEdit: boolean;
  types: any[] = [];
  actions: any[] = [];
  currentActionType: any[] = [];
  readonly: boolean[][] = [];
  actionType: any[] = [['COMBOBOX']];
  lastElem: string;

  @Input() set data(value) {

    if (value != null) {

      this.isFormulaEdit = value.isFormulaEdit;
      this.formulaForEdit = value.formulaForEdit;

    }
  }

  langs: any[] = [
    {
      id: 'ru',
      name: 'Русский'
    },
    {
      id: 'ne',
      name: 'Английский'
    },
    {
      id: 'kz',
      name: 'Казахский'
    }
  ]

  form: UntypedFormGroup = this.fb.group({
    formula_fields: this.fb.array([])
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private apiSpecificationsService: ApispecificationService,
    private validator: SpecificationsFormulaValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    if (this.isFormulaEdit) {

      this.getTypesList(0);
      setTimeout(() => this.setFormData(this.formulaForEdit), 1000);

    } else {

      this.getTypesList(0);
      this.addFormulaFields();
      this.addFormulaFields();
    }

  }


  /**
  * 
  */
  getTypesList(index: number, type: string = ''): void {

    this.progressRef.start();

    let data = {
      ref_name: 'spec_ref',
      filter: {
        input_type: type
      }
    }

    this.subscriptions.add(
      this.apiSpecificationsService.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getTypesList: ', response);

        if (response != null) {

          this.types[index] = response.result;

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  */
  getActions(index: number, type: string): void {

    this.progressRef.start();

    let data = {
      ref_name: "attr_spec_list",
      filter: {
        ref_type: type,
        input_type: this.currentActionType[index - 1] ? this.currentActionType[index - 1] : ''
      }
    }

    this.subscriptions.add(
      this.apiSpecificationsService.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getsActionsList: ', response);

        if (response != null && response.result != null) {

          this.actions[index] = response.result;

        } else {
          // При выборе типа "числовой" или "текстовы" перевызываем метод с текущим типом
          this.getTypesList(index + 1, 'STRING');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * 
  */
  addFormulaFields(): void {

    let control = this.form.controls.formula_fields as UntypedFormArray;
    control.push(this.initFormulaField());

    // this.getTypesListener(control.length - 1);
    // this.getActionsListener(control.length - 1);
  }

  /**
  * 
  * 
  */
  initFormulaField(): any {

    return this.fb.group({
      id: [null],
      type_field: [null, this.validator.type_field],
      value_type: [null, this.validator.value_type],
      lang_code: [null]
    });

  }

  /**
  * 
  */
  setFormData(formulaData) {

    if (formulaData != null && this.types.length > 0) {

      formulaData.forEach((element, index) => {

        this.addFormulaFieldsWithdata(element, index);

      });
    }
  }

  /**
  * 
  * @param type string
  */
  addFormulaFieldsWithdata(formulaData: any, index: number): void {

    console.log("FORMULA DATA: ", formulaData);


    let control = this.form.controls.formula_fields as UntypedFormArray;
    control.push(this.setFormulaData(formulaData, index));

    control.updateValueAndValidity();

    this.getTypesListener(index);
    this.getActionsListener(index);

  }

  /**
  * 
  * @param referenceData 
  * @returns 
  */
  setFormulaData(formulaData: any, index: number) {

    // Заполняем значение для отображение поля с нужным типом
    this.actionType[index] = formulaData.type_field.input_type;

    return this.fb.group({
      type_field: [formulaData.type_field, this.validator.type_field],
      id: [null],
      value_type: [formulaData.value_type, this.validator.value_type],
      lang_code: [formulaData.lang_code]
    });
  }

  /**
  * 
  * @param i number
  */
  removeFormulaField(i: number): void {

    let control = this.form.controls.formula_fields as UntypedFormArray;
    control.controls.splice(i);

    for (let i = 0; i < control.length; i++) {

      this.getTypesListener(i);
      this.getActionsListener(i);

    }

    control.updateValueAndValidity();

    // let control = this.form.controls.formula_fields as FormArray;

    // control.controls.splice(i, control.length-1);

    // this.getTypesListener(i);
    // this.getActionsListener(i);
  }



  /**
   * 
   */
  getTypesListener(index: number, formAction: boolean = false) {


    let currentVal = this.form.get(['formula_fields', index, 'type_field']).value;

    if (currentVal != null) {

      this.lastElem = currentVal.id;

      if (formAction) {

        this.form.get(['formula_fields', index, 'value_type']).setValue(null);
      }

      this.getActions(index, currentVal.id);
      this.actionType[index] = currentVal.input_type;

    }

    // this.subscriptions.add(

    //   this.form.get(['formula_fields', index, 'type_field']).valueChanges.subscribe(value => {

    //     if (value) {

    //       console.log("TYPE VALUE: ", value);

    //       this.lastElem = value.id;


    //       this.form.get(['formula_fields', index, 'value_type']).setValue(null);

    //       this.getActions(index, value.id);
    //       this.actionType[index] = value.input_type;

    //     }
    //   })
    // );

  }

  /**
   * 
   * @param index 
   */
  getActionsListener(index: number) {

    let currentVal = this.form.get(['formula_fields', index, 'value_type']).value;

    if (currentVal != null) {

      typeof (currentVal) == 'number' ? this.getTypesList(index + 1, 'NUMERIC') : this.getTypesList(index + 1, currentVal.input_type);

      this.currentActionType[index] = currentVal.input_type
      this.readonly[index] = currentVal.multilang;

    }



    // this.subscriptions.add(

    //   this.form.get(['formula_fields', index, 'value_type']).valueChanges.subscribe(value => {

    //     if (value) {

    //       console.log("VALUE FOR TYPES: ", value);

    //       typeof(value) == 'number' ? this.getTypesList(index + 1, 'NUMERIC') : this.getTypesList(index + 1, value.input_type);
    //       this.readonly[index] = value.multilang
    //     }
    //   })
    // );

  }



  /**
   * 
   */
  onSave() {

    let formula_fields: any[] = [];

    let control = this.form.controls.formula_fields as UntypedFormArray;

    for (let i = 0; i < control.controls.length; i++) {

      // if(control.value[i].type_field == "1"){

      formula_fields.push({

        id: control.value[i].value_type.id,
        name: control.value[i].value_type.name ? control.value[i].value_type.name : control.value[i].value_type,
        type: control.value[i].type_field.id ? control.value[i].type_field.id : null,
        lang_code: control.value[i].lang_code

      });

      // }


    }

    this.activeModal.close(control.value);

  }

  /**
 * 
 * @param field 
 * @param type 
 */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
